import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { successSocialAuthAction } from 'client/engagement-handlers/profile-engagement-handler/profile-engagement-handler';
import { getSocialProfile } from 'site-modules/shared/components/profile/idm/idm-utils';
import { getCurrentUser, socialSignIn } from 'site-modules/shared/components/profile/firebase-auth';
import { AUTH_PROVIDERS } from 'site-modules/shared/components/profile/auth-providers';
import { FirebaseErrors } from 'site-modules/shared/components/profile/firebase-errors';
import { firebaseValidation } from 'site-modules/shared/components/profile/firebase-validation';
import { SocialButton } from './social-button';

export function SocialSignInUI({
  firebaseError = null,
  parseFirebaseError,
  dataIdm,
  updateIdmDataOnLogin,
  signCompleted,
}) {
  const [spinnerActive, setSpinnerActive] = useState({
    appleButton: false,
    facebookButton: false,
    googleButton: false,
  });

  function handleSignIn({ currentTarget: { name } }) {
    const { spinner, provider, profileScope, authAction, providerId } = AUTH_PROVIDERS[name];
    setSpinnerActive({ [spinner]: true });

    getCurrentUser().then(usr => {
      const uid = usr?.uid;
      return socialSignIn(provider, profileScope, providerId)
        .then(() => {
          successSocialAuthAction({ value: authAction });
          return getSocialProfile(dataIdm, uid)
            .then(({ profile, aid }) => updateIdmDataOnLogin(profile, aid, true))
            .then(() => signCompleted());
        })
        .catch(error => {
          setSpinnerActive({ [spinner]: false });
          parseFirebaseError(error);
        });
    });
  }

  return (
    <div>
      <SocialButton
        name="google"
        className="mb-1"
        onSignIn={handleSignIn}
        isSpinnerActive={spinnerActive.googleButton}
      />
      <SocialButton
        name="facebook"
        className="mb-1"
        onSignIn={handleSignIn}
        isSpinnerActive={spinnerActive.facebookButton}
      />
      <SocialButton name="apple" onSignIn={handleSignIn} isSpinnerActive={spinnerActive.appleButton} />
      {firebaseError && (
        <ul className="social-sign-error h7 text-danger ps-1 mt-1">
          <FirebaseErrors error={firebaseError} />
        </ul>
      )}
    </div>
  );
}

SocialSignInUI.propTypes = {
  firebaseError: PropTypes.shape({}),
  parseFirebaseError: PropTypes.func.isRequired,
  dataIdm: PropTypes.shape({}).isRequired,
  updateIdmDataOnLogin: PropTypes.func.isRequired,
  signCompleted: PropTypes.func.isRequired,
};

export const SocialSignIn = firebaseValidation(SocialSignInUI);
